import React from "react";
import "./Loading.scss";

function Loading() {
  return <div className="Loading"></div>;
}

export default Loading;
